import script from "./ChapterTree.vue?vue&type=script&setup=true&lang=js"
export * from "./ChapterTree.vue?vue&type=script&setup=true&lang=js"

import "./ChapterTree.vue?vue&type=style&index=0&id=6e9855a1&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e9855a1"]])

export default __exports__